(() => {
  const selector = 'main .wt-featured-collection';
  const groups = new Set();
  const widths = new WeakMap();
  let pending = 0;
  const fit = () => {
    pending = 0;
    for (const group of groups) {
      if (!group.isConnected) { groups.delete(group); continue; }
      const links = [...group.querySelectorAll('.card__container > .card > .card__title > a')];
      const height = Math.ceil(Math.max(0, ...links.map(link => link.getBoundingClientRect().height)));
      if (height) group.style.setProperty('--amze-card-title-height', `${height}px`);
    }
  };
  const schedule = () => { if (!pending) pending = requestAnimationFrame(fit); };
  const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (widths.get(entry.target) !== width) {
        widths.set(entry.target, width);
        schedule();
      }
    }
  });
  const setup = () => {
    document.querySelectorAll(selector).forEach(group => {
      if (groups.has(group)) return;
      groups.add(group);
      group.querySelectorAll('.card__container > .card > .card__title > a').forEach(link => observer.observe(link));
    });
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.fonts.ready.then(schedule);
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', event => {
    for (const group of groups) {
      if (!event.target.contains(group)) continue;
      group.querySelectorAll('.card__title > a').forEach(link => observer.unobserve(link));
      groups.delete(group);
    }
  });
})();
